const ROOTS = {
  AUTH: '/auth',
  APP: '/app',
  ONBOARDING: '/onboarding',
  SPARTACUS: '/spartacus',
};

const paths = {
  onboarding: ROOTS.ONBOARDING,
  onboardingStep: (stepKey: string) => `${ROOTS.ONBOARDING}/${stepKey}`,
  onboardingDone: `${ROOTS.ONBOARDING}/done`,
  app: {
    social: `${ROOTS.APP}/social`,
    newPost: `${ROOTS.APP}/social/new`,
    socialCreate: `${ROOTS.APP}/social/create`,
    dashboard: `${ROOTS.APP}/dashboard`,
    reputation: `${ROOTS.APP}/reputation`,
    newReviewRequest: `${ROOTS.APP}/reputation/new`,
    listing: `${ROOTS.APP}/listing`,
    insights: `${ROOTS.APP}/insights`,
    jooiceai: `${ROOTS.APP}/jooiceai`,
    agents: `${ROOTS.APP}/jooiceai/agents`,
    chat: `${ROOTS.APP}/jooiceai/chat`,
    analytics: `${ROOTS.APP}/analytics`,
    account: `${ROOTS.APP}/account`,
    help: `${ROOTS.APP}/help`,
    orgSettings: `${ROOTS.APP}/org-settings`,
    location: `${ROOTS.APP}/org-settings/location`,
    install: `${ROOTS.APP}/install`,
    humanPlus: `${ROOTS.APP}/human-plus`,
    humanPlusAds: `${ROOTS.APP}/human-plus/adv`,
    messages: `${ROOTS.APP}/messages`,
  },
  spartacusOnboarding: `${ROOTS.SPARTACUS}/onboarding`,
  spartacusOnboardingV2: `${ROOTS.SPARTACUS}/onboarding-v2`,
  spartacus: {
    suggestions: `${ROOTS.SPARTACUS}${ROOTS.APP}/suggestions`,
    reviewsInbox: `${ROOTS.SPARTACUS}${ROOTS.APP}/reviews-inbox`,
    yourLocation: `${ROOTS.SPARTACUS}${ROOTS.APP}/your-location`,
    settings: `${ROOTS.SPARTACUS}${ROOTS.APP}/settings`,
    socialPlanner: `${ROOTS.SPARTACUS}${ROOTS.APP}/social-planner`,
    socialPlannerNewPost: `${ROOTS.SPARTACUS}${ROOTS.APP}/social-planner/new`,
    socialPlannerEditor: `${ROOTS.SPARTACUS}${ROOTS.APP}/social-planner/editor`,
    inbox: `${ROOTS.SPARTACUS}${ROOTS.APP}/inbox`,
    campaigns: `${ROOTS.SPARTACUS}${ROOTS.APP}/campaigns`,
  },
  purchase: '/purchase',
  clerkEmailLinkCallback: '/auth/clerk/email-link-callback',
  authTrial: '/auth/trial',
  //open route
  patientEnrollment: '/enroll',
};

export const buildPatientEnrollmentPath = (
  patientId: string | null,
  createdAt: string | null,
  organizationId: number,
) => `${paths.patientEnrollment}/${btoa(`${patientId}|${createdAt}|${organizationId}`)}`;

/** Builds the Customer Care patient profile path within the inbox. */
export const buildInboxPatientPath = (patientId: string) => `${paths.spartacus.inbox}/${patientId}`;

/** Location state when returning from patient profile to reopen a conversation. */
export type InboxReturnState = {
  openChatPatientId?: string;
};

export default paths;
